import PageHero from "../components/PageHero";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-medium text-navy mb-3">{title}</h2>
    <div className="space-y-3 text-base leading-relaxed text-slate-600">{children}</div>
  </div>
);

const Privacy = () => (
  <div data-testid="privacy-page">
    <PageHero overline="Legal" title="Privacy Policy" />
    <section className="bg-white">
      <div className="mx-auto max-w-3xl px-6 sm:px-8 lg:px-12 py-24 sm:py-28">
        <p className="text-sm text-slate-500 mb-12">Last updated: {new Date().getFullYear()}</p>

        <Section title="Information We Collect">
          <p>
            When you submit a contact or consultation request, we collect the information you provide,
            such as your name, company, email address, phone number, service of interest, and message.
          </p>
        </Section>
        <Section title="How We Use Your Information">
          <p>
            Inquiry data is used solely to respond to your request, schedule consultations, and provide
            information about our consulting services. We do not sell your personal information.
          </p>
        </Section>
        <Section title="SMS &amp; Mobile Information">
          <p>
            No mobile information will be shared with third parties or affiliates for marketing or
            promotional purposes. All the above categories exclude text messaging originator opt-in data
            and consent; this information will not be shared with any third parties.
          </p>
        </Section>
        <Section title="Contact &amp; Booking Form Handling">
          <p>
            Submissions are stored securely and accessed only by authorized Yana Capital Group personnel
            for the purpose of following up on your inquiry.
          </p>
        </Section>
        <Section title="Cookies &amp; Analytics">
          <p>
            We may use basic cookies and analytics to understand site usage and improve our website.
            You can control cookies through your browser settings.
          </p>
        </Section>
        <Section title="Contact for Privacy Concerns">
          <p>
            For any privacy-related questions, contact us at{" "}
            <a href="mailto:ScottWilson@yanacapitalgroup.com" className="text-gold hover:underline">
              ScottWilson@yanacapitalgroup.com
            </a>.
          </p>
        </Section>
      </div>
    </section>
  </div>
);

export default Privacy;
